export default __webpack_public_path__ + "static/logo-oreilly-c7416db722307871b18ca2fc9e8ca36b.png";